import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const defaultProps = {
    className: '',
};
const TableHead = ({ children, className = defaultProps.className, }) => (_jsx("thead", Object.assign({ className: className, css: css `
        height: ${theme.spacing.x12};
        border-bottom: ${styleUtils.rem(1)} solid ${theme.colors.gray300};
        background: ${theme.colors.gray200};
      ` }, { children: children })));
const MemoizedTableHead = memo(TableHead);
export { MemoizedTableHead as TableHead };
// MC-1068 Temporary hack for Storybook.
export default TableHead;
